import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useSelector, useAppDispatch } from 'rahtab-redux';
import { stockListSelector, addStock } from 'rahtab-redux/slices/stockListSlice';
import { useState, useEffect } from 'react';
export const useStockList = (assignFinalCode: string) => {
  const [idList, setIdList] = useState<Set<string> | undefined>();
  const stockList = useSelector(stockListSelector(Array.from(idList?.values() || [])));
  const dispatch = useAppDispatch();
  const [refetch, { called, loading }] = useFetchCallType<StockHistoryInfo[]>('GetAssignFinallStockHistory', {
    params: `AssignFinallCode=${assignFinalCode}`,
    onCompleted: (d) => {
      let temp = new Set<string>();
      d.forEach((stock) => {
        temp.add(stock.StockCode);
        dispatch(addStock(stock));
      });
      setIdList(temp);
    },
  });

  return {
    data: stockList,
    loading,
    called,
    refetch,
  };
};

export interface StockHistoryInfo {
  StockCode: string;
  StockDate: string;
  StockAmount: string;
  StockMeasureName: string;
  StockPrice: string;
  StockSaleAmount: string;
  StockSalePercent: string;
  StockFinishReason: string;
  StockFinishDate: string;
  TemplateCode: string;
  TemplateName: string;
  StatusCode: string;
  Status: string;
}
